import Panel from './panel.container';

export default Panel;
